import axios from 'axios';

import URLS from '../../util/urls';

const state = {
  listaAlugueisAtrasados: [],
  listaAlugueisAtrasadosMesAnterior: []
};

const mutations = {
  atualizarListaAlugueisAtrasados(state, payload) {
    state.listaAlugueisAtrasados = payload;
  },

  atualizarListaAlugueisAtrasadosMesAnterior(state, payload) {
    state.listaAlugueisAtrasadosMesAnterior = payload
  },

  limparAlugueis(state) {
    state.listaAlugueisAtrasados = [];
  },

  limparAlugueisMesAnterior(state) {
    state.listaAlugueisAtrasadosMesAnterior = []
  },
};

const actions = {
  recuperarAlugueisAtrasados(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_ALUGUEIS_ATRASADOS)
      .then((response) => {
        switch(response.data.status) {
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarAlugueisAtrasados');
              }
            }).catch((error) => {
              throw error;
            });
          default:
            return context.commit('atualizarListaAlugueisAtrasados', response.data.lista);
        }
      }).catch((error) => {
        throw error;
      });
  },

  recuperarAlugueisMesAnterior(context, payload) {
    return axios.post(URLS.DASHBOARD_RECUPERAR_ALUGUEIS_MES_ANTERIOR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('recuperarAlugueisMesAnterior', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return context.commit('atualizarListaAlugueisAtrasadosMesAnterior', response.data.lista);
      }
    }).catch((error) => {
      throw error;
    });
  }
};

export default {
  state,
  mutations,
  actions
};